import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import Select from 'react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import messages from '../course-creator/messages';
import Button from '../../components/button';
import { showToast } from '../../components/toast/actions';
import CurriculumTopicLink from '../../components/curriculum-topic-link';
import filterTopicTypes from './utils';
import {
    AddTopicContainer,
    ContentWrapper,
    Close,
    EditTopicHeader,
    RequiredFields,
    TopicName,
    ButtonsWrapper,
    Filters,
    FilterWrapper,
    TopicType,
    CurriculumLink,
    ExternalKey,
    Description,
    ErrorMessage
} from './styled';
import { Delete, Cross, Tick } from '../../helpers/icon-dictionary';
import SvgIcon from '../svg-icon/svg-icon';
import { MATHLETICS_PRODUCT_ID } from '../../constants';

const MAX_TOPIC_NAME_LENGTH = 50;
const MAX_STANDARD_NAME_LENGTH = 40;
const MAX_EXTERNAL_KEY_LENGTH = 32;
const MAX_DESCRIPTION_LENGTH = 1000;

const TOPIC_TYPES = {
    STRAND: 'strand',
    STANDARD: 'standard'
};

class AddTopic extends Component {
    constructor(props) {
        super(props);
        this.unsavedChanges = false;
        this.enableUpdate = false;
        this.strand = '';
        this.subStrand = '';
        this.topicType = '';
        this.subStrandFilterOptions = [];

        this.state = {
            selectedStrand: 'None',
            selectedSubStrand: 'None',
            topicName: '',
            externalKey: '',
            description: '',
            curriculumLevelCode: '',
            topicType: '',
            topicTypes: [],
            standardFilters: {},
            topicNameMaxLength: MAX_TOPIC_NAME_LENGTH,
            enableUpdate: false
        };

        this.handleOnUpdate = this.handleOnUpdate.bind(this);
        this.handleOnStrandChange = this.handleOnStrandChange.bind(this);
        this.handleOnSubstrandChange = this.handleOnSubstrandChange.bind(this);
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this);
        this.handleOnTopicNameChange = this.handleOnTopicNameChange.bind(this);
        this.getSubtrands = this.getSubtrands.bind(this);
    }

    componentWillReceiveProps(props) {
        const { modalData, parentData, modalType, standardFilters } = props;
        this.unsavedChanges = false;
        this.setUpdateButtonStatus();

        this.strandFilterOptions = Object.keys(props.standardFilters);
        this.strandFilterOptions = this.strandFilterOptions.map(strand => ({
            value: strand,
            label: strand.toUpperCase()
        }));

        this.strandFilterOptions.unshift({
            value: 'None', label: 'NONE'
        });

        this.strand = parentData.strand === '' ? modalData.strand : parentData.strand;
        this.subStrand = parentData.subStrand === '' ? modalData.subStrand : parentData.subStrand;

        this.setState({
            description: modalData.description || '',
            selectedStrand: this.strand,
            selectedSubStrand: this.subStrand,
            topicName: modalData.name || '',
            standardFilters,
            externalKey: modalData.externalKey || '',
            curriculumLevelCode: modalData.curriculumLevelCode,
            topicType: modalData.type || '',
            topicTypes: filterTopicTypes(modalType, parentData.type, this.props.topicTypes),
            topicNameMaxLength: modalData.type ? this.getTopicNameLength(modalData.type) : MAX_TOPIC_NAME_LENGTH,
            enableUpdate: false
        });

        this.getSubtrands(this.strand);
    }

    handleOnTopicNameChange = (e) => {
        const topicName = e.target.value;

        this.setState({
            topicName
        }, () => {
            this.setUpdateButtonStatus();
        });

        if (!this.unsavedChanges) {
            this.unsavedChanges = true;
        }
    }

    handleOnTopicTypeChange = (topicType) => {
        const maxLength = this.getTopicNameLength(topicType.value);

        this.setState({
            topicType: topicType.value,
            topicNameMaxLength: maxLength
        }, () => {
            this.setUpdateButtonStatus();
        });

        this.topicType = topicType.value;

        if (!this.unsavedChanges) {
            this.unsavedChanges = true;
        }
    }

    handleOnUpdate = () => {
        const { onClose, handleOnUpdateModal, id } = this.props;
        const { topicName, externalKey, description, curriculumLevelCode } = this.state;

        const updatedObject = {
            curriculumLevelCode,
            description,
            externalKey,
            strand: this.strand,
            subStrand: this.subStrand,
            topicId: id,
            topicName,
            topicType: this.topicType
        };

        handleOnUpdateModal(updatedObject);
        onClose(id);
    };

     getSubtrands = (strand = '') => {
         const { standardFilters } = this.state;
         if (standardFilters[strand]) {
             this.subStrandFilterOptions = standardFilters[strand].map(substrand => ({
                 value: substrand,
                 label: substrand
             }));
         }
         if (strand !== 'None') {
             this.subStrandFilterOptions.unshift({
                 value: 'None', label: 'None'
             });
         }
         return this.subStrandFilterOptions;
     }

     handleOnStrandChange = (strand) => {
         const { topicName, topicType } = this.state;

         this.subStrandFilterOptions = strand.value === 'None' ?
             [{
                 value: 'None', label: 'None'
             }] : this.getSubtrands(strand.value);

         this.strand = strand.value;
         const selectedSubStrand = strand.value === 'None' ? 'None' : this.subStrandFilterOptions[0].value;
         this.setState({
             selectedStrand: strand.value,
             selectedSubStrand
         });
         this.subStrand = selectedSubStrand;
         this.setUpdateButtonStatus();

         if (!this.unsavedChanges && topicName.trim().length && topicType !== '') {
             this.unsavedChanges = true;
         }
     };

     handleOnSubstrandChange = (subStrand) => {
         const { topicName, topicType } = this.state;
         this.setState({
             selectedSubStrand: subStrand.value
         });
         this.subStrand = subStrand.value;
         this.setUpdateButtonStatus();

         if (!this.unsavedChanges && topicName.trim().length && topicType !== '') {
             this.unsavedChanges = true;
         }
     };

     handleOnCloseModal = () => {
         const { id, intl, onClose } = this.props;
         this.strand = '';
         this.subStrand = '';
         this.setState({
             selectedStrand: 'None',
             selectedSubStrand: 'None'
         });
         onClose(id);
         if (this.unsavedChanges) {
             this.props.showToast(intl.formatMessage(messages.detailsNotSaved), 'warning');
         }
     }

     handleCurriculumChange = (selectedOption) => {
         this.setUpdateButtonStatus();
         if (selectedOption) {
             const { code, value, id } = selectedOption;
             this.setState({
                 externalKey: code,
                 description: value,
                 curriculumLevelCode: id
             }, () => {
                 this.setUpdateButtonStatus();
             });
         } else {
             this.setState({
                 externalKey: '',
                 description: '',
                 curriculumLevelCode: ''
             }, () => {
                 this.setUpdateButtonStatus();
             });
         }
     };

     handleKeyChange = (e) => {
         const externalKey = e.target.value || '';
         this.setUpdateButtonStatus();
         this.setState({
             externalKey
         });
     };

     handleDescriptionChange = (e) => {
         const description = e.target.value || '';
         this.setUpdateButtonStatus();
         this.setState({
             description
         });
     };

    handleOnDelete = () => {
        this.setState({ showDeleteConfirmation: true });
    }

    handleOnDeleteConfirm = () => {
        this.setState({ showDeleteConfirmation: false });
        const { id, onClose, onDelete } = this.props;
        onDelete(id);
        onClose();
    }

    handleOnDeleteCancel = () => {
        this.setState({ showDeleteConfirmation: false });
    }

    getTopicNameLength = (topicType) => {
        if (topicType.toUpperCase() === 'STANDARD') {
            return MAX_STANDARD_NAME_LENGTH;
        }

        return MAX_TOPIC_NAME_LENGTH;
    };

    getTopicNameErrorMessages = (intl) => {
        const { topicName, topicNameMaxLength } = this.state;
        if (topicName.length <= topicNameMaxLength) {
            return null;
        }

        return `${intl.formatMessage(messages.keepTopicNameLessThan)} ${this.state.topicNameMaxLength} ${intl.formatMessage(messages.characters)}`;
    };

    getIsCurriculumLinkRequired = () => {
        const { STRAND, STANDARD } = TOPIC_TYPES;
        const { selectedProduct } = this.props;
        const { topicType } = this.state;

        const topicTypeToLowercase = topicType.toLowerCase();
        const isRequiredTopicType = topicTypeToLowercase === STRAND || topicTypeToLowercase === STANDARD;
        const isMathletics = selectedProduct === MATHLETICS_PRODUCT_ID;

        return isRequiredTopicType && isMathletics;
    }

    setUpdateButtonStatus = () => {
        const { topicName, topicType, topicNameMaxLength, curriculumLevelCode } = this.state;

        const updatedCurriculumLevelCode = curriculumLevelCode || '';
        const hasRequiredFieldValues = !!topicName && !!topicType && topicName.trim().length <= topicNameMaxLength;

        let isEnabled;

        if (this.getIsCurriculumLinkRequired()) {
            isEnabled = updatedCurriculumLevelCode !== '' && hasRequiredFieldValues;
        } else {
            isEnabled = hasRequiredFieldValues;
        }

        this.setState({ enableUpdate: isEnabled });
    };

    render() {
        const { show, intl, curriculumLevelDescriptions, modalType } = this.props;
        const { externalKey = '', description = '', curriculumLevelCode = '' } = this.state;
        const topicErrorMessage = this.getTopicNameErrorMessages(intl);

        if (show) {
            return (
                <AddTopicContainer>
                    <ContentWrapper>
                        <Close onClick={this.handleOnCloseModal}>X</Close>
                        <EditTopicHeader>Edit Topic Details</EditTopicHeader>
                        <RequiredFields>Required fields</RequiredFields>
                        <TopicName hasError={topicErrorMessage != null}>
                            <span>{intl.formatMessage(messages.topicName)}</span>
                            <input
                                maxLength={this.state.topicNameMaxLength}
                                name="topicName"
                                onChange={this.handleOnTopicNameChange}
                                type="text"
                                value={this.state.topicName} />
                            <ErrorMessage>{topicErrorMessage}</ErrorMessage>
                        </TopicName>
                        <TopicType>
                            <span>{intl.formatMessage(messages.topicType)}</span>
                            <Select
                                className="topicTypeSelect"
                                isDisabled={modalType === 'edit'}
                                onChange={this.handleOnTopicTypeChange}
                                options={this.state.topicTypes}
                                placeholder={this.state.topicType || 'Select...'}
                                value={this.state.topicType} />
                        </TopicType>
                        <FilterWrapper>
                            <Filters>
                                <label htmlFor="strandFilter">{intl.formatMessage(messages.strandFilter)}</label>
                                <Select
                                    id="strandFilter"
                                    onChange={this.handleOnStrandChange}
                                    options={this.strandFilterOptions}
                                    placeholder={this.state.selectedStrand.toUpperCase()}
                                    value={this.state.selectedStrand} />
                            </Filters>
                            <Filters>
                                <label htmlFor="subStrandFilter">{intl.formatMessage(messages.subStrandFilter)}</label>
                                <Select
                                    id="subStrandFilter"
                                    onChange={this.handleOnSubstrandChange}
                                    options={this.subStrandFilterOptions}
                                    placeholder={this.state.selectedSubStrand.toUpperCase()}
                                    value={this.state.selectedSubStrand} />
                            </Filters>
                        </FilterWrapper>
                        <CurriculumLink
                            isRequired={this.getIsCurriculumLinkRequired()}
                        >
                            <span>{intl.formatMessage(messages.curriculumLevelLink)}</span>
                            <CurriculumTopicLink
                                curriculumLevelDescriptions={curriculumLevelDescriptions}
                                defaultValue={{ value: this.state.description, label: this.props.defaultDescription }}
                                handleCurriculumChange={this.handleCurriculumChange}
                                placeholder={intl.formatMessage(messages.curriculumLinkPlaceholder)} />
                        </CurriculumLink>
                        <ExternalKey>
                            <span>{intl.formatMessage(messages.externalKey)}</span><input disabled={curriculumLevelCode} maxLength={MAX_EXTERNAL_KEY_LENGTH} name="externalKey" onChange={this.handleKeyChange} type="text" value={externalKey} />
                        </ExternalKey>
                        <Description>
                            <span>{intl.formatMessage(messages.description)}</span><textarea disabled={curriculumLevelCode} maxLength={MAX_DESCRIPTION_LENGTH} name="description" onChange={this.handleDescriptionChange} value={description} />
                        </Description>
                        <ButtonsWrapper>
                            <div className="deletePanel">
                                {
                                    !this.state.showDeleteConfirmation ? (<div
                                        className="iconStyle"
                                        onClick={this.handleOnDelete}
                                        role="button"
                                        tabIndex="-1"><SvgIcon icon={Delete} /></div>)
                                        : (<div className="confirmationPanel">
                                            <div className="message">Are you sure you would like to remove?</div>
                                            <div className="buttonPanel">
                                                <div className="cross">
                                                    <div
                                                        className="btnIconStyle"
                                                        onClick={this.handleOnDeleteCancel}
                                                        role="button"
                                                        tabIndex="-1"><SvgIcon icon={Cross} /></div></div>
                                                <div className="tick">
                                                    <div><div
                                                        className="btnIconStyle"
                                                        onClick={this.handleOnDeleteConfirm}
                                                        role="button"
                                                        tabIndex="-1"><SvgIcon icon={Tick} /></div></div></div>
                                            </div>
                                        </div>)
                                }
                            </div>
                            <div><Button
                                disabled={!this.state.enableUpdate}
                                handleOnClick={this.handleOnUpdate}
                                label={intl.formatMessage(messages.update)}
                                primary
                            /></div>
                        </ButtonsWrapper>
                    </ContentWrapper>
                </AddTopicContainer>
            );
        }
        return null;
    }
}

AddTopic.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    intl: intlShape.isRequired,
    standardFilters: PropTypes.object,
    showToast: PropTypes.func,
    handleOnUpdateModal: PropTypes.func,
    id: PropTypes.string,
    modalData: PropTypes.object,
    curriculumLevelDescriptions: PropTypes.array,
    defaultDescription: PropTypes.string,
    topicTypes: PropTypes.array,
    modalType: PropTypes.string,
    parentData: PropTypes.object,
    onDelete: PropTypes.func,
    selectedProduct: PropTypes.number
};

AddTopic.defaultProps = {
    show: true,
    name: '',
    strand: 'None',
    subStrand: 'None',
    topicTypes: [],
    parentData: {},
    standardFilters: {}
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        showToast
    }, dispatch);
}

export default connect(() => ({}), mapDispatchToProps)(AddTopic);



// WEBPACK FOOTER //
// ./app/components/add-topic/index.js